import React from 'react'
import ImageManagementContainer from '../../templates/image-management/ImageManagementContainer'
import withParams from '../../../modules/router-manage/withParams'
import PortalHeader from '../../templates/navbar/PortalHeader'
import Navbar from '../../templates/navbar/Navbar'

const ImageManagementPage = ({ portalID }) => (
  <div>
    <Navbar portalID={portalID} />
    <div className="container">
      <div className="section">
        <PortalHeader portalID={portalID} />
        <hr />
        <ImageManagementContainer />
      </div>
    </div>
  </div>
)

export default withParams(ImageManagementPage)



// WEBPACK FOOTER //
// ./src/components/pages/web/ImageManagementPage.js